module.exports = "/img/cate-family.e2837ec8.png";